// CatalogGrid.jsx
import React from "react";
import SC from "./style";
import { Button } from "@InnoUI/";
import theme from "@theme/";
import { formatDateTime } from "utils/helper";
import { projectType } from "utils/lookUpTable";

const CatalogGrid = (props) => {
  const { catalogs = [], onView = () => {} } = props;

  const handleKey = (e, catalog) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onView(catalog);
    }
  };

  // 👉 Show message when no catalogs exist
  if (!catalogs.length) {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "40px 0",
          fontSize: "16px",
          color: "#777",
          fontWeight: 500,
        }}
      >
        No catalogs available.
      </div>
    );
  }

  return (
    <SC.Grid role="list">
      {catalogs.map((cat) => {
        const photoCount = cat.photoCount || 0;
        const videoCount = cat.videoCount || 0;

        let containsText = "Contains no photos";

        if (photoCount > 0 && videoCount > 0) {
          containsText = `Contains ${photoCount} photos and ${videoCount} videos`;
        } else if (photoCount > 0) {
          containsText = `Contains ${photoCount} photos`;
        } else if (videoCount > 0) {
          containsText = `Contains ${videoCount} videos`;
        }

        return (
          <SC.Card
            key={cat.catalogId}
            role="listitem"
            tabIndex={0}
            aria-label={`Catalog ${cat.catalogName}. ${containsText}.`}
            onKeyDown={(e) => handleKey(e, cat)}
            onClick={() => onView(cat)}
          >
            <SC.CardInner>
              <SC.CatalogInfo>
                <SC.Title fulltext={cat.catalogName}>
                  {cat.catalogName}
                </SC.Title>
                <SC.CatalogDate>
                  {formatDateTime(cat.date, "DD-MM-YYYY")}
                </SC.CatalogDate>
                <SC.CatalogCount>{containsText}</SC.CatalogCount>
                <SC.CatalogCount>
                  {cat.projectType == projectType.occupant && cat.occupantName
                    ? `${cat.occupantName} - ${cat.occupantNo}`
                    : `${cat.projectName}`}
                </SC.CatalogCount>
              </SC.CatalogInfo>

              <SC.CatalogActions>
                <Button
                  caption={"view"}
                  onClick={() => onView(cat)}
                  color={theme.colors.themeColor}
                  fontSize="12px"
                  maxLength={30}
                  disabled={cat.permission === 0}
                  style={{
                    marginBottom: 8,
                    background: "white",
                    color: theme.colors.white,
                    height: "28px",
                    borderRadius: "5px",
                    boxShadow: "0 6px 16px rgba(0, 0, 0, 0.08)",
                    border: `1px solid ${theme.colors.bordertask}`,
                  }}
                />
              </SC.CatalogActions>
            </SC.CardInner>
          </SC.Card>
        );
      })}
    </SC.Grid>
  );
};

export default CatalogGrid;
